// extracted by mini-css-extract-plugin
module.exports = {"buttonStyle":"user-form_buttonStyle__Z6AaL","step":"user-form_step__TOJ_B","button":"user-form_button__16bKG"};